var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3205_108663)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3205_108663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.091 7.68092L12.2737 7.16159C11.4553 6.93086 10.7098 6.49397 10.1085 5.89272C9.50728 5.29147 9.07039 4.54598 8.83967 3.72759L8.32033 1.91026C8.29421 1.84667 8.24978 1.79229 8.19269 1.75402C8.13559 1.71575 8.0684 1.69531 7.99967 1.69531C7.93093 1.69531 7.86374 1.71575 7.80664 1.75402C7.74955 1.79229 7.70512 1.84667 7.679 1.91026L7.15967 3.72759C6.92894 4.54598 6.49205 5.29147 5.8908 5.89272C5.28955 6.49397 4.54406 6.93086 3.72567 7.16159L1.90833 7.68092C1.83855 7.70073 1.77714 7.74276 1.73341 7.80063C1.68968 7.8585 1.66602 7.92906 1.66602 8.00159C1.66602 8.07413 1.68968 8.14468 1.73341 8.20255C1.77714 8.26043 1.83855 8.30245 1.90833 8.32226L3.72567 8.84159C4.54406 9.07232 5.28955 9.50921 5.8908 10.1105C6.49205 10.7117 6.92894 11.4572 7.15967 12.2756L7.679 14.0929C7.6988 14.1627 7.74083 14.2241 7.7987 14.2678C7.85657 14.3116 7.92713 14.3352 7.99967 14.3352C8.0722 14.3352 8.14276 14.3116 8.20063 14.2678C8.2585 14.2241 8.30053 14.1627 8.32033 14.0929L8.83967 12.2756C9.07039 11.4572 9.50728 10.7117 10.1085 10.1105C10.7098 9.50921 11.4553 9.07232 12.2737 8.84159L14.091 8.32226C14.1608 8.30245 14.2222 8.26043 14.2659 8.20255C14.3097 8.14468 14.3333 8.07413 14.3333 8.00159C14.3333 7.92906 14.3097 7.8585 14.2659 7.80063C14.2222 7.74276 14.1608 7.70073 14.091 7.68092Z",
    fill: "url(#paint0_linear_3205_108663)",
    fillOpacity: 0.56
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3205_108663",
    x: -0.333984,
    y: 0.695312,
    width: 16.668,
    height: 16.6406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.392157 0 0 0 0 0.219608 0 0 0 0 0.960784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3205_108663"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3205_108663",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3205_108663",
    x1: 0.846211,
    y1: 12.244,
    x2: 15.6078,
    y2: 12.5165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A36BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#672F94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3205_108663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDark);
export default __webpack_public_path__ + "static/media/starDark.d5634a0d7bc3fd7e2173be487ee2732d.svg";
export { ForwardRef as ReactComponent };